import { render } from "./articleEditor.vue?vue&type=template&id=f46fba76"
import script from "./articleEditor.vue?vue&type=script&lang=js"
export * from "./articleEditor.vue?vue&type=script&lang=js"

import "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__